export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  color: string;
  videoCount: number;
}

export const categories: Category[] = [
  {
    slug: 'xigua',
    name: '西瓜视频',
    description: '搞笑娱乐、生活日常、创意短视频，汇聚全网最有趣的原创内容',
    icon: 'ri-trophy-line',
    color: 'from-green-400 to-emerald-600',
    videoCount: 2586,
  },
  {
    slug: 'tangdou',
    name: '糖豆视频',
    description: '舞蹈健身、广场舞教学、养生运动，中老年群体的欢乐天地',
    icon: 'ri-heart-pulse-line',
    color: 'from-pink-400 to-rose-600',
    videoCount: 3421,
  },
  {
    slug: 'xiaolan',
    name: '小蓝视频',
    description: '科技数码、知识科普、编程教学，探索前沿技术与新知',
    icon: 'ri-lightbulb-line',
    color: 'from-cyan-400 to-teal-600',
    videoCount: 1893,
  },
  {
    slug: 'mangguo',
    name: '芒果视频',
    description: '热门综艺、真人秀、脱口秀，全网最受欢迎的综艺内容',
    icon: 'ri-tv-line',
    color: 'from-yellow-400 to-orange-600',
    videoCount: 4127,
  },
  {
    slug: 'sigua',
    name: '丝瓜视频',
    description: '热播剧集、经典电影、动漫番剧，追剧达人的不二之选',
    icon: 'ri-film-line',
    color: 'from-lime-400 to-green-600',
    videoCount: 5678,
  },
  {
    slug: 'lanmei',
    name: '蓝莓视频',
    description: '纪录片、自然风光、人文历史，用镜头探索世界的精彩',
    icon: 'ri-earth-line',
    color: 'from-indigo-400 to-purple-600',
    videoCount: 1234,
  },
];